import { FEATURE_IDS_KEY, ORIGINAL_FEATURE_IDS_KEY } from '../../services/attributeService'
import CategoryUtils from "../../common/CategoryUtils"

function getFeatureIds(p: any): string[] | null | undefined {
  if (!p) return null
  return p?.attributes?.attributes?.[FEATURE_IDS_KEY]?.choices || p?.attributes?.attributes?.[ORIGINAL_FEATURE_IDS_KEY]?.choices
}

function getDisplayCategory(categoryIds: string[]) {
  return CategoryUtils.categoryCNById(categoryIds) || categoryIds?.join(',')
}

export { getDisplayCategory, getFeatureIds }
